import React from "react";
import { useTranslation } from "react-i18next";

import CardColumn from "components/CardColumn";
import classnames from "classnames";

interface Props {
	className?: string;
}
const ViewHeadings = ({ className }: Props) => {
	const { t } = useTranslation();

	return (
		<div
			className={classnames(
				"list-group-heading tasks__heading",
				className
			)}>
			<CardColumn
				className="view-modal-card--heading__title"
				width="xl"
				ariaLabel={t("main.views.labels.source") + " column"}>
				{t("main.views.labels.source")}
			</CardColumn>
			<CardColumn
				className="view-modal-card--heading__desc"
				width="fill"
				ariaLabel={t("main.views.labels.description") + " column"}>
				{t("main.views.labels.description")}
			</CardColumn>
		</div>
	);
};

export default ViewHeadings;
